import React, { useState } from 'react';
import copy from 'copy-to-clipboard';
import { useTranslation } from 'react-i18next';
import SocialShareButtons from '../../SocialShareButtons';
import LinkIcon from '../../Icons/Link';
import { IconSize } from '../../Icons/IconWrap';
import { BiButton, BiEventType } from '../../biLogger';
import { getDeviationShareCodes } from '../helpers';
import { getTranslatedDeviationTitle } from '../../DeviationViews/_helpers';
import s from './MobileSharePopup.scss';
export var MobileSharePopup = function (_a) {
    var deviation = _a.deviation;
    var t = useTranslation().t;
    var _b = useState(false), copied = _b[0], setCopied = _b[1];
    var url = getDeviationShareCodes(deviation).url;
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['title'] }, t('share.via')),
        React.createElement(SocialShareButtons, { className: s['social-buttons'], buttonClassname: s['social-button'], shareButtonClassname: s['social-button-inner'], nameClassname: s['button-text'], url: url, title: (deviation && getTranslatedDeviationTitle(deviation, t)) || '', buttons: ['facebook', 'twitter', 'tumblr', 'pinterest'], iconSize: 42, iconBgColor: "#0e0d20" // L8
            , logoFillColor: "#00e59b" // G3
            , showName: true }),
        React.createElement("div", { className: s['footer'] },
            React.createElement(BiButton, { biData: { evid: BiEventType.CLICK_COPY }, className: s['copy-button'], onClick: function () {
                    copy(url);
                    setCopied(true);
                } },
                React.createElement(LinkIcon, { size: IconSize.BIG }),
                React.createElement("span", { className: s['button-text'] }, t(copied ? 'share.copied' : 'share.copyLink'))))));
};
MobileSharePopup.displayName = 'MobileSharePopup';
export default MobileSharePopup;
//# sourceMappingURL=MobileSharePopup.js.map